import { darken } from "polished";
import * as React from "react";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
const Left = (props) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", ...props },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 11c0 6.05-4.95 11-11 11S0 17.05 0 11 4.95 0 11 0s11 4.95 11 11zm-11 8c4.411 0 8-3.589 8-8s-3.589-8-8-8v16z", fill: props.fill })));
};
const Right = (props) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", style: { transform: 'scaleX(-1)' }, ...props },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 11c0 6.05-4.95 11-11 11S0 17.05 0 11 4.95 0 11 0s11 4.95 11 11zm-11 8c4.411 0 8-3.589 8-8s-3.589-8-8-8v16z", fill: props.fill })));
};
const Whole = (props) => {
    return (React.createElement("svg", { viewBox: "250.905 134.349 22 22", width: 22, height: 22, ...props },
        React.createElement("path", { clipRule: "evenodd", d: "M272.905 145.349c0 6.05-4.95 11-11 11s-11-4.95-11-11 4.95-11 11-11 11 4.95 11 11z", paintOrder: "fill", fillRule: "evenodd", fill: props.fill })));
};
const FlexContainer = styled.div.attrs((props) => ({
    selectable: props.selectable,
})) `
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ selectable }) => !selectable && `
    cursor: not-allowed;
  `}

  &:active {
    pointer-events: ${(props) => props.selectable ? 'auto' : 'none'};
  }

  & > :not([hidden]) ~ :not([hidden]) {
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }
`;
const MultiplierContainer = styled.div `
  font-weight: bold;
  font-size: 1rem;
  background-color: ${(props) => props.title === 'single' ? props.theme.colors.primary : darken(0.25, props.theme.colors.primary)};
  color: ${({ theme }) => theme.colors.primary_text};
  padding: 2px 5px;
  border-radius: 4px;
`;
class DishOptionSetPizzaControlClass extends React.Component {
    clickCount;
    multipliers;
    constructor(props) {
        super(props);
        this.clickCount = 0;
        this.multipliers = ['none', 'single', 'double'];
    }
    getPositionAndMultiplier = () => {
        const position = this.props.option.position;
        const multiplier = this.props.option.quantity_multiplier;
        if (!position || !multiplier) {
            return ['', 'none'];
        }
        return [position, multiplier];
    };
    handlePositionChanged = (newPosition) => {
        const [position, multiplier] = this.getPositionAndMultiplier();
        // If we changed to a new topping position,
        // we also reset the quantity multiplier to 'single'
        // and increase click counter to 1. This simulates
        // the process of switching position.
        if (newPosition !== position) {
            this.clickCount = 1;
            this.props.onUpdate(newPosition, 'single');
            return;
        }
        else {
            this.clickCount++;
            // If the click counter exceeded the number of
            // quantity multiplier, we reset the position
            // and multiplier to 'empty' state. This allows
            // client to deselect a given option set option.
            if (this.clickCount >= this.multipliers.length) {
                this.clickCount = 0;
                this.props.onUpdate('', 'none');
                return;
            }
            // Otherwise, we cycle through quantity multipliers
            // as the client click the topping position icon.
            let nextMultiplier = multiplier;
            const index = this.multipliers.findIndex(val => val === multiplier);
            if (index !== -1) {
                nextMultiplier = this.multipliers[(index + 1) % this.multipliers.length];
            }
            this.props.onUpdate(newPosition, nextMultiplier);
        }
    };
    getPositionActiveColor = (isActive, multiplier) => {
        if (!isActive) {
            return '#DDDDDD';
        }
        const primaryColor = this.props.theme.colors.primary;
        switch (multiplier) {
            case 'single':
                return primaryColor;
            case 'double':
                return darken(0.25, primaryColor);
            default:
                return primaryColor;
        }
    };
    getMultiplierText = (multiplier) => {
        switch (multiplier) {
            case 'single':
                return 'x1';
            case 'double':
                return 'x2';
            default:
                return '';
        }
    };
    render() {
        const [position, multiplier] = this.getPositionAndMultiplier();
        const multiplierText = this.getMultiplierText(multiplier);
        const rawPrice = this.props.rawPrice;
        const shouldShowPrice = !!(this.props.showPrice && !(rawPrice <= 0 || rawPrice === '0'));
        const isPriceAvailable = this.props.isPriceDataAvailable;
        return (React.createElement(FlexContainer, { selectable: isPriceAvailable },
            !(multiplier === 'none' || multiplier === 'single') && (React.createElement(MultiplierContainer, { title: multiplier }, multiplierText)),
            shouldShowPrice && (React.createElement("div", { className: "div-r-2 small" }, this.props.price)),
            React.createElement(FlexContainer, { selectable: isPriceAvailable },
                React.createElement(Left, { fill: this.getPositionActiveColor(position === 'left', multiplier), onClick: () => this.handlePositionChanged('left') }),
                React.createElement(Whole, { fill: this.getPositionActiveColor(position === 'whole', multiplier), onClick: () => this.handlePositionChanged('whole') }),
                React.createElement(Right, { fill: this.getPositionActiveColor(position === 'right', multiplier), onClick: () => this.handlePositionChanged('right') }))));
    }
}
export const DishOptionSetPizzaControl = withTranslation()(DishOptionSetPizzaControlClass);
//# sourceMappingURL=index.js.map